module.exports = "/img/p4f.svg?21b3a08b94a117f5e360f8a7657635fc";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/p4f.svg
// module id = OCwF
// module chunks = 70